import "./Loader.css";
import { useSelector } from "react-redux";

const Loaders = () => {
    const gallery = useSelector((state) => state.loader);

  return (
    <div className="loader-overlay">
      <img src="/assets/image/loader.gif" alt="Loading..." className="loader-gif" />
    </div>
  );
};

export default Loaders;
